import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Routing } from '../../app.routes';
import { ProjectStateService } from '../../shared/services/state/project-state.service';

export const stepperGuard: CanActivateFn = (route, state) => {
  const store: ProjectStateService = inject(ProjectStateService);
  const router = inject(Router);
  const url = route.routeConfig?.path;
  let isAuthorized: boolean = false;
  const path = store.getGuardPath();
  // Si pas de path renseigner dans le sessionStorage -> 403
  if (!path) {
    router.navigate([Routing.UNAUTHORIZED]).then();
  } else if (url) {
    isAuthorized = url === path;
  }
  return isAuthorized;
};
